import { registerLocaleData } from '@angular/common';
import vi from '@angular/common/locales/vi';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserTracing, init, replayIntegration, routingInstrumentation } from '@sentry/angular-ivy';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { Environment } from '@us/app-config';
import { httpClientIntegration } from '@sentry/integrations';

const env: Environment = environment as Environment;

registerLocaleData(vi);

if (env.production) {
    init({
        // dsn: 'https://3f00d7ee0f5133dec34ae605a45377b5@sentry.posapp.vn/4',
        dsn: 'https://e1a0b16722ce4087842a9e320457aa55@o923189.ingest.us.sentry.io/5918177',
        integrations: [
            new BrowserTracing({
                routingInstrumentation: routingInstrumentation
            }),
            replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
                networkDetailAllowUrls: ['https://api-order.posapp.vn']
            }),
            httpClientIntegration()
        ],
        // This option is required for capturing headers and cookies.
        sendDefaultPii: true,
        tracesSampleRate: 1.0,
        tracePropagationTargets: ['localhost', 'https://api-order.posapp.vn/v1'],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        environment: env.sentryEnvironment,
        release: `${env.version}-${env.sentryEnvironment}`
    });

    enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch(err => {
    console.error(err);
    throw err;
});
